// AuthenticationCheck.js
import { createContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./auth"; // ✅ use the shared exported instance

export const AuthContext = createContext();
// AuthenticationCheck.js
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
    // logger.log("Auth state updated:", firebaseUser);
    setUser(firebaseUser);
    setLoading(false);
  });
  return () => unsubscribe();
}, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};